// ** Initial State
const initialState = {
  data: [],
  params: {},
  selectedLog: null
}

const agenticLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_AGENTIC_LOGS_DATA':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    case 'GET_AGENTIC_LOG':
      return {
        ...state,
        selectedLog: action.selectedLog
      }
    default:
      return state
  }
}

export default agenticLogsReducer
